<template>
    <div class="d-flex flex-column">

        <h2 class="p-3 border-bottom-light">Company Settings</h2>

        <div class="text-center mt-4" v-if="loadingSettings">
            <loader></loader>
        </div>

        <div v-else class="content">
            <tabs>
                <tab name="PROFILE">
                    <tabCompany :company="companySettings" @save="saveSettings"></tabCompany>
                </tab>
                <tab name="PRESETS">
                    <tabPresets :presets="companySettings.settingsPresets" @save="saveSettings"></tabPresets>
                </tab>
                <tab name="BOOKING WIDGET">
                    <tabWidget @save="saveSettings"></tabWidget>
                </tab>
                <!-- <tab name="Invoices">
                    <tabInvoices :invoices="companySettingsOld.invoices" @save="saveSettings"></tabInvoices>
                </tab> -->
                <!-- <tab name="Payment Method">
                    <tabPaymentMehtod :paymentmethod="companySettingsOld.paymentMethod" @save="saveSettings"></tabPaymentMehtod>
                </tab> -->
                <!-- <tab name="Channel Manager">
                    <tabTicket></tabTicket>
                </tab> -->
                <tab name="INTEGRATIONS">
                    <tabIntegrations :presets="companySettings.settingsPresets" @save="saveSettings"></tabIntegrations>
                </tab>
                <tab name="ACCOUNTS">
                    <tabAccounts></tabAccounts>
                </tab>
                <tab name="SALES CHANNELS">
                    <tabSalesChannels></tabSalesChannels>
                </tab>
            </tabs>
        </div>



    </div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'
    import {mapGetters, mapActions} from 'vuex'
    import Loader from '@/tools/loaders/loader1'

    import tabCompany from './TabCompany'
    import tabPresets from './TabPresets'
    import tabInvoices from './TabInvoices'
    import tabPaymentMehtod from './TabPaymentMehtod'
    import tabTicket from './TabTicket'
    import tabAccounts from './TabAccounts'
    import tabWidget from './TabWidget'
    import tabIntegrations from './TabIntegrations'
    import tabSalesChannels from './TabSalesChannels'

    export default {
        created: function(){
            // this.initCompany().then((value => {
            //     // this.setLoadingDone();
            //     console.log('this.getCompanyInfo', (this.getCompanyInfo.id));
            // }))
        },
        data: function() {
            return {
                // loadingSettings: false,
            }
        },
        computed:{
            ...mapGetters([
                'getCompanyInfo',
                'getCompanySettings',
                'getIsDonwloadingCompanySettings'
            ]),
            companySettingsOld: function(){
                return this.getCompanyInfo
            },
            companySettings: function(){
                return this.getCompanySettings
            },
            loadingSettings: function () {
                return this.getIsDonwloadingCompanySettings || !this.companySettings.id
            }
        },
        methods:{
            ...mapActions([
                'initCompany',
                'updateCompany'
            ]),
            saveSettings: function(){
                console.log('Sent to save')
                console.log(this.companySettingsOld);
                this.updateCompany(this.companySettingsOld);
            },
            setLoadingDone: function(){
                // this.loadingSettings = false;
            }
        },
        components:{
            vSelect: extendedVSelect,
            tabCompany,
            tabPresets,
            tabInvoices,
            tabPaymentMehtod,
            tabTicket,
            tabAccounts,
            tabWidget,
            tabIntegrations,
            tabSalesChannels,
            Loader
        }
    }
</script>

<style scoped lang="scss">
  .yScroll{
    overflow-y: auto;
  }

</style>



// WEBPACK FOOTER //
// Settings.vue?9534de22